/**
 * WeaponStaff — arcane battle staff.
 * Glowing crystal orb at the tip; long straight shaft with runic bands.
 * Renders as an SVG <g> group in the knight's coordinate space (25×25).
 */
export default function WeaponStaff() {
  return (
    <g>
      {/* Outer glow ring */}
      <circle cx="22" cy="3"   r="4"   fill="none" stroke="#c080ff" strokeWidth="0.8" opacity="0.5"/>
      {/* Orb outer crystal */}
      <circle cx="22" cy="3"   r="3"   fill="#8030d0"/>
      {/* Orb inner glow */}
      <circle cx="22" cy="3"   r="2.2" fill="#a050f0"/>
      {/* Orb highlight */}
      <circle cx="21" cy="2"   r="0.9" fill="#e8d0ff" opacity="0.9"/>
      {/* Orb bottom connector to shaft */}
      <rect   x="21.2" y="5.5" width="1.8" height="1.5" rx="0.3" fill="#6030a0"/>
      {/* Shaft */}
      <rect   x="21.3" y="6.5" width="1.6" height="17"  rx="0.6" fill="#6a5a3a"/>
      {/* Shaft accent line */}
      <rect   x="21.7" y="7"   width="0.5" height="16"  rx="0.2" fill="#9a8a5a" opacity="0.55"/>
      {/* Runic bands */}
      <rect   x="20.8" y="11"  width="2.6" height="0.9" rx="0.3" fill="#8030d0" opacity="0.80"/>
      <rect   x="20.8" y="17"  width="2.6" height="0.9" rx="0.3" fill="#8030d0" opacity="0.60"/>
      {/* Butt cap */}
      <circle cx="22"  cy="24.5" r="1.4" fill="#4a3a28" stroke="#9060e0" strokeWidth="0.6"/>
    </g>
  );
}
